import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=26e30be6&"
import script from "./Blog.vue?vue&type=script&lang=js&"
export * from "./Blog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e30be6')) {
      api.createRecord('26e30be6', component.options)
    } else {
      api.reload('26e30be6', component.options)
    }
    module.hot.accept("./Blog.vue?vue&type=template&id=26e30be6&", function () {
      api.rerender('26e30be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Blog.vue"
export default component.exports